import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { Subject, tap, takeUntil } from 'rxjs';
import { autoCompleteRequired } from '../../validators/autocompleteRequired';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-users-dropdown',
  templateUrl: './users-dropdown.component.html',
  styleUrl: './users-dropdown.component.scss'
})
export class UsersDropdownComponent {

  _unsubscribe$: Subject<boolean> = new Subject()

  form = this.fb.group({
    user_id: ['', [autoCompleteRequired()]],
  })

  @Input() label:string = "Common.UserId"
  @Input() isRequired:boolean = false
  @Output() updateParent: EventEmitter<any> = new EventEmitter();

  dataSource:any[] = []
  timeOut:any=0

  constructor(
    private userService: UserService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.getUsers()
    if(this.isRequired){
      this.form.get('user_id')?.addValidators(Validators.required)
    }
  }

  /*----------------------Functions Called from parent---------------------- */
  // setValue(data){
  //   // console.log("eventdata",data)
  //   this.userVal = `[${data.Service_Id}] - ${data.Service_Id}`;
  // }

  reset(){
    this.form.reset()
    this.updateParent.emit("");
  }

  /*----------------------Getting Users for dropdown select---------------------- */

  onType(value: string) {
    if (value.length == 0 || value.length > 1) {
      clearTimeout(this.timeOut)
      this.timeOut = setTimeout(() => {
        this.dataSource=[]
        this.getUsers(value)
      }, 1000)
    }
  }

  getUsers(searchValue:string='') {
    let body = {
      pageNo:1,
      pageSize: 100,
      isPaginated: false,
      searchString:searchValue
    }
     this.userService.GetUsers(body)
     .pipe(
      tap(
        (result) => {
          if(result.IsSuccess && result.Data.users){
            this.dataSource = result.Data.users;
          }
        }
      ),
      takeUntil(this._unsubscribe$),
    )
    .subscribe();
  }


  /*----------------------when Choosing User---------------------- */
  changeSelected(selectedValue:any){ 
    // console.log("selected",selectedValue)
    if(selectedValue){
      // let phone= (this.form.get('user_id')?.value as any).PhoneNumber
      // this.updateParent.emit(phone);   
      let Id= (this.form.get('user_id')?.value as any).Id
      this.updateParent.emit(Id);   
    }else{
      this.updateParent.emit("");   
    }
  }

  displayFn(item:any) {
    if (!item) return '';
    let index = this.dataSource.findIndex(e => e.Id == item.Id);
    return `[${this.dataSource[index].PhoneNumber}] - ${this.dataSource[index].UserFullName}`;
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next(true)
    this._unsubscribe$.complete()
  }
}
